const getParamByName = (name, params = document.location.search.substring(1)) => {
  const searchParams = new URLSearchParams(params)
  return searchParams.get(name)
}

export default getParamByName
